//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'
import SearchOtherBoatTypesInLocation from '../components/search/page/search-other-boat-types-in-location.vue'
import dayjs from '~/modules/dayjs'
import pageMeta, { mxGetMeta } from '~/mixins/pageMeta'
import OffersInMailbox from '~/components/section/offers-in-mailbox'
import { asyncDataCatch, asyncDataStart } from '~/utils/asyncData'
import urlTranslator from '~/middleware/url-translator'
import { isWindow } from '~/plugins/v-js'
//import bnrSpring from '~/components/banners/bnrSpring.vue'
import FaqItems from '~/components/Flotillas/FaqItems'
import faq from '~/mixins/faq'
import oldDate from '~/middleware/oldDate'
import searchUtils from '~/mixins/search/search-utils'
import SearchOtherLocations from '~/components/search/page/search-other-locations.vue'
import SearchTitle from '~/components/search/search-title.vue'
import SearchModals from '~/components/search/page/search-modals.vue'
import SearchComponent from '~/components/search/page/search-component.vue'
import PageTop from '~/components/section/page-top.vue'
import gtm from '~/mixins/gtm'

export default {
  name: 'SearchPage',
  components: {
    PageTop,
    SearchOtherBoatTypesInLocation,
    SearchComponent,
    SearchModals,
    SearchTitle,
    SearchOtherLocations,
    OffersInMailbox,
    //bnrSpring,
    FaqItems
  },
  mixins: [pageMeta, faq, searchUtils, gtm],
  middleware: [oldDate, urlTranslator],
  async asyncData (ctx) {
    await asyncDataStart(ctx)

    try {
      const lang = ctx.store.getters['lang/locale']
      const locationUrl = ctx.route.params.location
      const path = `/${lang}/search/${locationUrl}/` +
        (ctx.route.params.boatType ? `${ctx.route.params.boatType}/` : '') +
        (ctx.route.params.charterType ? `${ctx.route.params.charterType}/` : '')
      await mxGetMeta(ctx, {
        meta: {
          method: 'dynamic',
          type: 'location',
          path,
          idx: ctx.route.query?.locations ?? locationUrl,
          params: {
            idx: locationUrl,
            boat_type: ctx.route.params.boatType,
            page: ctx.route.params.page,
            charter_type: ctx.route.params.charterType,
            locations: ctx.route.query?.locations ?? ''
          }
        }
      })

      if (ctx.route.params.page) {
        ctx.store.commit('search/SET_LOCATIONS', { currentPage: ctx.route.params.page })
      }

      if (ctx.route.query && ctx.route.query.start_date) {
        let date = dayjs().weekday(6).format('YYYY-MM-DD')
        if (ctx.route.query.start_date) {
          date = ctx.route.query.start_date
        }
        ctx.store.commit('search/SET_DATE', date)
        const duration = ctx.route.query.duration
        if (duration) {
          ctx.store.commit('search/SET_DURATION', duration)
        }
      }

      if (locationUrl) {
        await ctx.store.dispatch('search/getLocation', {
          locationUrl,
          lang,
          locations: ctx.route?.query?.locations?.split(',')
        })
      }
      ctx.store.dispatch('auth/getFavorites')
      await ctx.store.dispatch('search/urlConfig', ctx.route.path)
      return {
        lang
      }
    } catch (e) {
      return asyncDataCatch(ctx, e)
    }
  },
  data () {
    return {
      page: {
        loading: true
      }
    }
  },
  watch: {
    '$route.fullPath' () {
      this.createdMethod()
    }
  },
  computed: {
    ...mapGetters({
      userCredits: 'auth/userCredits',
      pageFaq: 'page/pageFaq'
    }),
    ...mapState({
      breakpoint: state => state.breakpoint,
      currentCurrency: state => state.lang.currentCurrency,
      pageSeoData: state => state.pageData,
      location: state => state.search.locationFull,
      filters: state => state.search.filters,
      boatType: state => state.search?.boatType?.boat_type_id,
      hasBeenFiltered: state => state.search.hasBeenFiltered,
      canBeReset: state => state.search.canBeReset
    })
  },
  async mounted () {
    this.createdMethod(true)
    this.onSetPage()
    this.$nuxt.$on('setSort', (ev) => {
      this.sortBy = ev
    })

    window.addEventListener('popstate', () => {
      const url = new URL(window.location.href)
      setTimeout(() => {
        this.$Search.setAttributeValue('page', this.$router.resolve(url.pathname)?.route?.params?.page || 1)
        this.$Search.search().finally(() => {

        })
      }, 500)
    });

    this.$nuxt.$on('searchUpdated', async (ev) => {
      const locationUrl = this.$route.params.location
      const boatType = this.getBoatTypeSlug(ev.boatType)
      const path = `/${this.lang}/search/${locationUrl}/` +
        (boatType ? `${boatType}/` : '') +
        (this.$route.params.charterType ? `${this.$route.params.charterType}/` : '')

      const type = 'location'
      const locations = ev.locations.join(',')
      const idx = locations ?? locationUrl
      const params = {
        idx,
        boat_type: boatType,
        page: this.$route.params.page,
        charter_type: this.$route.params.charterType,
        locations: locations ?? ''
      }

      try {
        const dtD = await this.$store.dispatch('getDynamicTags', { path, type, idx, params })
        this.$store.dispatch('setPageTags', dtD)
      } catch (e) {
        //
      }
    })
  },
  destroyed () {
    this.$nuxt.$off('searchUpdated')
    this.$nuxt.$off('setSort')
  },
  beforeRouteLeave (to, from, next) {
    // this.$Search.resetAllAttributes()
    // if (!['search', 'search_with_boat', 'search_with_boat_charter'].includes(to.name)) {
    //   this.$store.commit('search/RESET_FILTERS_SHOW_LIMITS')
    //   this.$Search.resetAllAttributes()
    // }
    next()
  },
  methods: {
    async fetchFAQ (isVisible) {
      if (!isVisible) {
        return
      }
      if (this.pageFaq.loaded || this.pageFaq.loading) {
        return
      }
      if (!this.location?.ids?.country) {
        return
      }
      await this.$store.dispatch('page/fetchFAQ', {
        country_id: this.location.ids.country,
        defaultParam: 'null'
      }).catch((e) => {
        console.log(e)
      })
    },
    onSetPage () {
      this.$scrollTo({ y: 0 })
    },
    createdMethod () {
      try {
        this.$Search.syncSearchByUrl()
        this.$Search.setClientUrl().then(() => {
          this.$Search.search()
        })
        this.page.loading = false

        if (isWindow() && this.$store.state.search.date) {
          let parsed = []
          const url = this.$route.fullPath
          const std = this.getStartDate.toISOString()
          const bt = this.getBoatTypeId || 0
          const data = window.localStorage.getItem('searches')
          if (data) {
            parsed = JSON.parse(data)
            if (!parsed.find((item) => {
              return (item.id === this.location.id && item.start_date === std && item.boatTypeId === bt)
            })) {
              parsed.push({
                id: this.location.id,
                image: this.getTopImage,
                start_date: std,
                end_date: this.getEndDate,
                boatType: this.getBoatTypeTitle,
                boatTypeId: bt,
                location: (this.location.location)[this.location.type],
                search: url
              })
            }
          } else {
            parsed.push({
              id: this.location.id,
              image: this.getTopImage,
              start_date: std,
              end_date: this.getEndDate,
              boatType: this.getBoatTypeTitle,
              boatTypeId: bt,
              location: (this.location.location)[this.location.type],
              search: url
            })
          }
          window.localStorage.setItem('searches', JSON.stringify(parsed.slice(-5)))

          const pageShift = this.pagination.currentPage === 1 ? 0 : (this.pagination.currentPage - 1) * this.pagination.perPage
          this.gtm.viewItemList({
            items: this.getSearchResult?.map((result, index) => {
              return {
                id: result.id,
                name: result.name,
                price: result.discounts.newPrice,
                brand: result.brand,
                list: 'Search Results',
                position: pageShift + index + 1
              }
            })
          })

          if (this.pagination.currentPage === 1) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: 'search_correct',
              searchTerm: this.searchTerms
            })
          }
        }
      } catch (e) {

        if (isWindow()) {
          this.gtm.setCustomTag({ event: 'custom_search_Error' })
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            event: 'search_incorrect',
            searchTerm: this.searchTerms
          })
        }
      }
    }
  }
}
